import { render, staticRenderFns } from "./user-password.vue?vue&type=template&id=23b81f5c&"
import script from "./user-password.vue?vue&type=script&lang=js&"
export * from "./user-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports